<template>
  <div class="container" >
      <div v-html="list" style="width:50%"></div>
  </div>
</template>

<script>
import {getPrivacy} from '@/api/system'
export default {
    data() {
        return {
            list: []

        }
    },
    created() {
        getPrivacy({
            type: 2,
        }).then(res => {
            if(res.code == 200) {
              this.list = res.data.content
            } else {
                this.$message.error(res.msg)

            }
        })

    },
    methods: {

    }

}
</script>

<style scoped>
.container {
     display: flex;
	justify-content: center;
	/* align-items: center; */


}

</style>